module.exports = __webpack_public_path__ + "rental-portfolio-cover-2.16669f5.png";